<template>
  <div id="prioritarias">
    <div class="info-table">
      <div class="info-table-item download-right">
        <b-dropdown variant="secondary" size="sm" class="ml-2 dropdown-files">
          <template #button-content>
            <i class="icofont-download"></i> Exportar
          </template>
          <b-dropdown-item @click="generatePdf">
            <i class="icofont-file-pdf"></i> PDF
          </b-dropdown-item>
          <b-dropdown-item @click="exportarXlsPersonalizado">
            <i class="icofont-file-excel"></i> XLS
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar por INEP, Escola ou Equipe"
              class="input-bottom"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            :mobile-breakpoint="0"
            @pagination="getPagination"
            :page="currentPage"
            :options.sync="options"
            :server-items-length="filteredRecords.length"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, por favor, espere"
            :headers="dynamicHeaders"
            :items="currentPageRecords"
            :single-expand="false"
            :expanded.sync="expanded"
            item-key="id"
            :show-expand="true"
            class="elevation-1"
          >
            <template v-slot:header.qtd_atvds_alimentacao="{ header }">
              <div class="table-col-header">
                {{ header.text }}
                <span
                  v-b-tooltip.hover.right
                  title="03 - Alimentação saudável"
                  class="icon-tooltip"
                >
                  <i class="icofont-info-circle"></i>
                </span>
              </div>
            </template>
            <template v-slot:header.qtd_atvds_paz="{ header }">
              <div class="table-col-header">
                {{ header.text }}
                <span
                  v-b-tooltip.hover.right
                  title="09 - Prevenção da violência e promoção da cultura da paz"
                  class="icon-tooltip"
                >
                  <i class="icofont-info-circle"></i>
                </span>
              </div>
            </template>
            <template v-slot:header.qtd_atvds_reproducao="{ header }">
              <div class="table-col-header">
                {{ header.text }}
                <span
                  v-b-tooltip.hover.right
                  title="14 - Saúde sexual e reprodutiva"
                  class="icon-tooltip"
                >
                  <i class="icofont-info-circle"></i>
                </span>
              </div>
            </template>
            <template v-slot:header.qtd_atvds_vacinacao="{ header }">
              <div class="table-col-header">
                {{ header.text }}
                <span
                  v-b-tooltip.hover.right
                  title="12 - Verificação da situação vacinal"
                  class="icon-tooltip"
                >
                  <i class="icofont-info-circle"></i>
                </span>
              </div>
            </template>
            <template v-slot:header.qtd_atvds_saude_mental="{ header }">
              <div class="table-col-header">
                {{ header.text }}
                <span
                  v-b-tooltip.hover.right
                  title="13 - Saúde mental"
                  class="icon-tooltip"
                >
                  <i class="icofont-info-circle"></i>
                </span>
              </div>
            </template>

            <template v-slot:item.qtd_atvds_alimentacao="{ item }">
              <button
                class="btn btn-default btn-modal"
                :class="
                  item.qtd_atvds_alimentacao == null ||
                  item.qtd_atvds_alimentacao == 0
                    ? 'red'
                    : ''
                "
                @click="
                  selectedModalItem(item, 'alimentacao', 'Alimentação saudável')
                "
              >
                {{
                  item.qtd_atvds_alimentacao == null
                    ? '0'
                    : item.qtd_atvds_alimentacao
                }}
              </button>
            </template>

            <template v-slot:item.qtd_atvds_paz="{ item }">
              <button
                class="btn btn-default btn-modal"
                :class="
                  item.qtd_atvds_paz == null || item.qtd_atvds_paz == 0
                    ? 'red'
                    : ''
                "
                @click="
                  selectedModalItem(
                    item,
                    'paz',
                    'Prevenção da violência e promoção da cultura da paz'
                  )
                "
              >
                {{ item.qtd_atvds_paz == null ? '0' : item.qtd_atvds_paz }}
              </button>
            </template>

            <template v-slot:item.qtd_atvds_reproducao="{ item }">
              <button
                class="btn btn-default btn-modal"
                :class="
                  item.qtd_atvds_reproducao == null ||
                  item.qtd_atvds_reproducao == 0
                    ? 'red'
                    : ''
                "
                @click="
                  selectedModalItem(
                    item,
                    'reproducao',
                    'Saúde sexual e reprodutiva'
                  )
                "
              >
                {{
                  item.qtd_atvds_reproducao == null
                    ? '0'
                    : item.qtd_atvds_reproducao
                }}
              </button>
            </template>

            <template v-slot:item.qtd_atvds_vacinacao="{ item }">
              <button
                class="btn btn-default btn-modal"
                :class="
                  item.qtd_atvds_vacinacao == null ||
                  item.qtd_atvds_vacinacao == 0
                    ? 'red'
                    : ''
                "
                @click="
                  selectedModalItem(
                    item,
                    'vacinacao',
                    'Verificação da situação vacinal'
                  )
                "
              >
                {{
                  item.qtd_atvds_vacinacao == null
                    ? '0'
                    : item.qtd_atvds_vacinacao
                }}
              </button>
            </template>

            <template v-slot:item.qtd_atvds_saude_mental="{ item }">
              <button
                class="btn btn-default btn-modal"
                :class="
                  item.qtd_atvds_saude_mental == null ||
                  item.qtd_atvds_saude_mental == 0
                    ? 'red'
                    : ''
                "
                @click="selectedModalItem(item, 'mental', 'Saúde mental')"
              >
                {{
                  item.qtd_atvds_saude_mental == null
                    ? '0'
                    : item.qtd_atvds_saude_mental
                }}
              </button>
            </template>

            <template v-slot:expanded-item="{ item }">
              <td :colspan="totalColumns" class="table-expand-details">
                <div class="expanded-content">
                  <table class="table table-expand">
                    <thead>
                      <tr>
                        <th>Data</th>
                        <th>Profissional</th>
                        <th>CBO</th>
                        <th>Participantes</th>
                        <th>Atividades</th>
                        <th class="export-col">
                          <b-dropdown size="sm" class="dropdown-files">
                            <template #button-content>
                              <i class="icofont-download"></i> Exportar
                            </template>
                            <b-dropdown-item @click="exportTeamData(item)">
                              <i class="icofont-file-pdf"></i> PDF
                            </b-dropdown-item>
                            <b-dropdown-item @click="exportTeamXls(item)">
                              <i class="icofont-file-excel"></i> XLS
                            </b-dropdown-item>
                          </b-dropdown>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detail, index) in item.details" :key="index">
                        <td>{{ formatDate(detail.data) }}</td>
                        <td>{{ detail.no_profissional }}</td>
                        <td>{{ detail.co_cbo }}</td>
                        <td>{{ detail.nu_participantes }}</td>
                        <td>{{ detail.tipo_atividade }}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao">
                {{ currentPageTotal }} de {{ overallTotal }} atividades
              </span>
            </template>

            <template v-slot:progress>
              <v-progress-linear color="blue" :height="10" indeterminate />
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>

    <modal-prioritarias
      :series="modal.series"
      :active.sync="modal.active"
      :item="modal.item"
      :tipoAtividade="modal.tipo_atividade"
      :atividade="modal.atividade"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as Functions from './functions.js'
import store from '@/store/store'
import ModalPrioritarias from './components/ModalPrioritarias.vue'

export default {
  name: 'Prioritarias',
  components: {
    ModalPrioritarias,
  },
  data() {
    return {
      search: '',
      loading: false,
      currentPage: 1,
      expanded: [],
      ultimaAtualizacao: this.$store.getters['getUltimaAtualizacao'],
      dynamicHeaders: [
        { text: 'INEP', value: 'inep' },
        { text: 'Escola', value: 'no_escola' },
        { text: 'Equipe', value: 'no_equipe' },
        {
          text: '03',
          value: 'qtd_atvds_alimentacao',
          sortable: true,
        },
        { text: '09', value: 'qtd_atvds_paz', sortable: true },
        {
          text: '12',
          value: 'qtd_atvds_vacinacao',
          sortable: true,
        },
        {
          text: '13',
          value: 'qtd_atvds_saude_mental',
          sortable: true,
        },
        {
          text: '14',
          value: 'qtd_atvds_reproducao',
          sortable: true,
        },
        // { text: 'Estudantes', value: 'qtd_estimado_alunos' },
        { text: '', value: 'data-table-expand' },
      ],
      records: [],
      modal: {
        active: false,
        item: null,
        series: [],
        tipo_atividade: '',
        atividade: '',
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      escolas: [],
    }
  },
  computed: {
    ...mapState(['store']),
    totalColumns() {
      return this.dynamicHeaders.length
    },
    filteredRecords() {
      if (!this.search) return this.records

      const searchLower = this.search.toLowerCase()
      return this.records.filter(
        (record) =>
          record.inep?.toString().includes(searchLower) ||
          record.no_escola?.toLowerCase().includes(searchLower) ||
          record.no_equipe?.toLowerCase().includes(searchLower)
      )
    },
    currentPageRecords() {
      const items = [...this.filteredRecords]

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      // aplica ordenação manual
      if (sortBy.length) {
        items.sort((a, b) => {
          const key = sortBy[0]
          const desc = sortDesc[0]

          const va = Number(a[key]) || 0
          const vb = Number(b[key]) || 0

          return desc ? vb - va : va - vb
        })
      }

      const start = (page - 1) * itemsPerPage
      const end = start + itemsPerPage
      return items.slice(start, end)
    },
    currentPageTotal() {
      return this.currentPageRecords.reduce((total, record) => {
        const sumRecord =
          (Number(record.qtd_atvds_alimentacao) || 0) +
          (Number(record.qtd_atvds_paz) || 0) +
          (Number(record.qtd_atvds_reproducao) || 0) +
          (Number(record.qtd_atvds_vacinacao) || 0) +
          (Number(record.qtd_atvds_saude_mental) || 0)
        return total + sumRecord
      }, 0)
    },
    overallTotal() {
      return this.filteredRecords.reduce((total, record) => {
        const sumRecord =
          (Number(record.qtd_atvds_alimentacao) || 0) +
          (Number(record.qtd_atvds_paz) || 0) +
          (Number(record.qtd_atvds_reproducao) || 0) +
          (Number(record.qtd_atvds_vacinacao) || 0) +
          (Number(record.qtd_atvds_saude_mental) || 0)
        return total + sumRecord
      }, 0)
    },
    exportedXlsData() {
      return this.filteredRecords.map((record) => ({
        INEP: record.inep,
        Escola: record.no_escola,
        Equipe: record.no_equipe,
        '03': record.qtd_atvds_alimentacao,
        '09': record.qtd_atvds_paz,
        12: record.qtd_atvds_vacinacao,
        13: record.qtd_atvds_saude_mental,
        14: record.qtd_atvds_reproducao,
      }))
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      if (dateStr.includes('-')) {
        const [year, month, day] = dateStr.split('-')
        return `${day}/${month}/${year}`
      }
      return new Date(dateStr).toLocaleDateString('pt-BR')
    },
    getPagination(e) {
      this.currentPage = e.page
    },
    async generatePdf() {
      try {
        const mainTableHeaders = [
          'INEP',
          'Escola',
          'Equipe',
          '03',
          '09',
          '12',
          '13',
          '14',
        ]
        const mainTableKeys = [
          'inep',
          'no_escola',
          'no_equipe',
          'qtd_atvds_alimentacao',
          'qtd_atvds_paz',
          'qtd_atvds_vacinacao',
          'qtd_atvds_saude_mental',
          'qtd_atvds_reproducao',
        ]
        const pdfTitle = 'PSE - Prioritárias'

        await Functions.generatePdf(
          this.filteredRecords,
          mainTableHeaders,
          mainTableKeys,
          pdfTitle
        )
        this.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
          position: 'topRight',
        })
      } catch (error) {
        this.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
          position: 'topRight',
        })
      }
    },
    async exportarXlsPersonalizado() {
      try {
        const cidade = store.state.cidade || 'Cidade'
        const titulo = 'PSE - Programa saúde na escola'
        const descricao_secretaria = 'SECRETARIA MUNICIPAL DE SAÚDE'
        const descricao =
          'Atividades realizadas no Programa Saúde na Escola (2025 a 2026)'
        const dataAtual = new Date().toLocaleDateString()
        const subtitulo = 'Atividades coletivas por escola'
        const nomeArquivo = `PSE_Prioritarias_${cidade}_${
          new Date().toISOString().split('T')[0]
        }`

        await Functions.exportarXlsCustomizado(
          this.exportedXlsData,
          nomeArquivo,
          cidade,
          titulo,
          descricao_secretaria,
          descricao,
          dataAtual,
          subtitulo,
          this.dynamicHeaders.map((h) => h.text)
        )
        this.$toast.success('XLS GERADO COM SUCESSO!', 'Sucesso:', {
          position: 'topRight',
        })
      } catch (error) {
        this.$toast.error('ERRO AO GERAR XLS!', 'Erro:', {
          position: 'topRight',
        })
      }
    },
    async exportTeamData(item) {
      try {
        const headers = [
          { text: 'Data', value: 'data' },
          { text: 'Profissional', value: 'no_profissional' },
          { text: 'CBO', value: 'co_cbo' },
          { text: 'Participantes', value: 'nu_participantes' },
          { text: 'Atividades', value: 'tipo_atividade' },
        ]
        await Functions.exportTeamPdf(item)
        this.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
          position: 'topRight',
        })
      } catch (error) {
        this.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
          position: 'topRight',
        })
      }
    },
    async exportTeamXls(item) {
      try {
        const cidade = store.state.cidade || ''
        const titulo = 'PSE - Programa saúde na escola'
        const descricao_secretaria = 'SECRETARIA MUNICIPAL DE SAÚDE'
        const descricao =
          'Atividades realizadas no Programa Saúde na Escola (2025 a 2026)'
        const dataAtual = new Date().toLocaleDateString()
        const subtitulo = `INEP: ${item.inep}\nEscola: ${
          item.no_escola || ''
        }\nEquipe: ${item.no_equipe || ''}`

        const dados = (item.details || []).map((detail) => ({
          Data: this.formatDate(detail.data),
          Profissional: detail.no_profissional,
          CBO: detail.co_cbo,
          Participantes: detail.nu_participantes,
          Atividades: detail.tipo_atividade,
        }))

        const nomeArquivo = `PSE_Prioritarias_${item.no_escola || 'Escola'}_${
          item.inep
        }_${cidade}`

        const teamColumnOrder = [
          'Data',
          'Profissional',
          'CBO',
          'Participantes',
          'Atividades',
        ]

        await Functions.exportarXlsCustomizado(
          dados,
          nomeArquivo,
          cidade,
          titulo,
          descricao_secretaria,
          descricao,
          dataAtual,
          subtitulo,
          teamColumnOrder
        )
        this.$toast.success('XLS GERADO COM SUCESSO!', 'Sucesso:', {
          position: 'topRight',
        })
      } catch (error) {
        this.$toast.error('ERRO AO GERAR XLS!', 'Erro:', {
          position: 'topRight',
        })
      }
    },
    async fetchData() {
      try {
        this.loading = true
        this.escolas = []
        const response = await this.$api.get(
          `/app/v2/pse/${this.$store.state.cod_ibge}?tipo=prioritarias`
        )
        if (response && response.data) {
          const response2 = await this.$api.get(
            `/app/utils/escolas-br/${this.$store.state.cod_ibge}`
          )
          if (response2) {
            this.escolas = response2.data
          }
          this.records = response.data.map((item, index) => {
            let details = []
            if (item.dados_atvdds) {
              try {
                details = JSON.parse(item.dados_atvdds)
              } catch (e) {
                console.error('Erro ao parsear dados_atvdds:', e)
                details = []
              }
            }
            return {
              id: index,
              ...item,
              details: details,
            }
          })
        }
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
      } finally {
        this.loading = false
      }
    },
    selectedModalItem(item, tipo, atividade) {
      this.modal.active = true
      this.modal.item = item
      this.modal.tipo_atividade = tipo
      this.modal.atividade = atividade
      let escola = this.escolas.find((el) => {
        return el.inep == item.inep
      })
      let estimativa = 0
      if (escola?.dados) {
        let dados = JSON.parse(escola.dados)
        estimativa = dados?.qtd_educandos ?? 0
      }
      let participantes = 0

      switch (tipo) {
        case 'alimentacao':
          participantes = item.qtd_parts_atvds_alimentacao
          break
        case 'paz':
          participantes = item.qtd_parts_atvds_paz
          break
        case 'reproducao':
          participantes = item.qtd_parts_atvds_reproducao
          break
        case 'mental':
          participantes = item.qtd_parts_atvds_saude_mental
          break
        case 'vacinacao':
          participantes = item.qtd_parts_atvds_vacinacao
          break
        default:
          break
      }

      let estudantesAindaNaoAtendidos =
        Number(estimativa) - Number(participantes)
      this.modal.series = [
        {
          data: [
            estimativa,
            participantes,
            estudantesAindaNaoAtendidos < 0 ? 0 : estudantesAindaNaoAtendidos,
          ],
        },
      ]
    },
  },
  created() {
    this.fetchData()
  },
  watch: {
    search() {
      this.currentPage = 1
    },
  },
}
</script>

<style scoped lang="scss">
#prioritarias {
  padding: 20px 0;
  .btn-modal {
    width: 70px;
    margin: 0 auto;
    display: block;
    color: #fff !important;
  }
  .table-col-header {
    border: 1px solid;
    text-align: center;
    border-radius: 8px;
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 4px 0;
    margin: 0 auto;
  }
}

.info-table {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -10px;
}

.download-right {
  margin-left: auto;
}

.app-tabela {
  background: transparent !important;
}

.box {
  background: #fff;
  border-radius: 5px;
}

.tabela {
  width: 100%;
}

.input-bottom {
  margin-bottom: 0;
}

.v-data-table ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table ::v-deep .v-data-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.table-expand-details {
  background-color: #f8f9fa;
  padding: 0;
}

.expanded-content {
  padding: 10px 20px;
}

.table-expand {
  margin: 20px 0;
  width: 100%;
  table-layout: auto;
}

.export-col {
  width: 100px;
  text-align: right;
}

.export-col .dropdown-files {
  display: inline-block;
}

.export-col .dropdown-files .btn {
  white-space: nowrap;
}

.paginacao {
  margin-left: auto;
  padding-right: 20px;
}

.tabela-esus-pec {
  margin-left: 20px;
}
</style>
